import React, { useState, useEffect, useCallback } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { injectIntl } from 'react-intl';
import { Grid, Box, CircularProgress } from '@material-ui/core';
import CardHolder from 'app/components/CardHolder';

import styles from './styles';
import CustomTable from 'app/components/CustomTable';
import Filter from '../Filter';
import daesEndpoint from 'app/api/services/daesEndpoint';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import { showLoading, hideLoading } from 'app/store/slices/settings';
const useStyles = makeStyles(styles);

function FinancialPendencies(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { intl } = props;

  const [openFilter, setOpenFilter] = useState(false);
  const [filters, setFilters] = useState({});
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});

  const activeCompany = useSelector(state => state.company.activeCompany);
  const registrationUserInfo = useSelector(state => state.auth.registrationInfo);

  const onClick = async (item, v) => {
    const position = v.tableData.id;
    if (data[position].originalData) {
      dispatch(showLoading());
      try {
        const localOriginalData = data[position].originalData;
        const response = await daesEndpoint.showDAE(
          localOriginalData.nuAnoGru,
          localOriginalData.nuGru,
          localOriginalData.nuDocumento
        );
        if (response?.status === 200 && response?.data) {
          const downloadLink = document.createElement('a');
          downloadLink.target = '_blank';
          downloadLink.download = 'DAE.pdf';

          const blob = new Blob([response.data], { type: 'application/pdf' });

          const URL = window.URL || window.webkitURL;
          const downloadUrl = URL.createObjectURL(blob);

          downloadLink.href = downloadUrl;
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
          URL.revokeObjectURL(downloadUrl);
        }
      } catch (error) {
      }
      dispatch(hideLoading());
    }
  };

  const parseDataRow = useCallback(
    values => {
      const dataRow = values.map(item => {
        const temp = (
          <Grid container className={classes.listItem}>
            <Grid item xs={6} className={classes.textLeft}>
              <Box color="secondary.main">
                Vencimento: {moment.utc(item.dtVencimento).format('DD/MM/YYYY')}
              </Box>
            </Grid>
            <Grid item xs={6} className={classes.textRight}>
              Solicitação: {item.nuSolicitacaoFmt}
            </Grid>
            <Grid item xs={6} className={classes.textLeft}>
              {`DAE: ${item.nuDocumento}/${item.nuAnoSolicitacao}`}
            </Grid>
            {item.servicos && item.servicos.length > 0 && (
              <Grid item xs={6} className={classes.textRight}>
                Valor:{' '}
                {Number(item.servicos[0].valor).toLocaleString('pt-br', {
                  style: 'currency',
                  currency: 'BRL',
                })}
              </Grid>
            )}
          </Grid>
        );
        return { data: temp, originalData: item };
      });
      setData(dataRow);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const findDaes = useCallback(
    async filtersParam => {
      try {
        setLoading(true);
        const aditionalFilters = {};
        if (filtersParam) {
          if (filtersParam.nuSolicitacaoFmt)
            aditionalFilters.nuSolicitacaoFmt = filtersParam.nuSolicitacaoFmt;
          if (filtersParam.nuGruFmt) aditionalFilters.nuGruFmt = filtersParam.nuGruFmt;
          if (filtersParam.dtPeriodoInicial)
            aditionalFilters.dtPeriodoInicial = filtersParam.dtPeriodoInicial;
          if (filtersParam.dtPeriodoFinal)
            aditionalFilters.dtPeriodoFinal = filtersParam.dtPeriodoFinal;
          if (filtersParam.cdServico) aditionalFilters.cdServico = filtersParam.cdServico;
        }

        const deCnpjMatriz = activeCompany.deCnpjMatriz
          ? activeCompany.deCnpjMatriz
          : registrationUserInfo.deCpfCnpj
          ? registrationUserInfo.deCpfCnpj
          : null;
        if (deCnpjMatriz) {
          const search = {
            page: 0,
            size: 5,
            request: {
              ...aditionalFilters,
              deCnpjMatriz,
              daesPendentes: true,
            },
          };

          const response = await daesEndpoint.getDAEs(search);
          if (
            response.status === 200 &&
            response.data?.content &&
            response.data?.content.length > 0
          ) {
            parseDataRow(response.data.content);
          }
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    },
    [activeCompany.deCnpjMatriz, parseDataRow, registrationUserInfo.deCpfCnpj]
  );

  useEffect(() => {
    findDaes();
  }, [findDaes]);

  const columns = [
    {
      title: 'Dados',
      field: 'data',
      cellStyle: {
        fontSize: '12px',
      },
    },
  ];

  const handleSendFilter = cleaning => {
    if (cleaning) findDaes();
    if (!cleaning && Object.keys(filters).length > 0) {
      findDaes(filters);
    }
    setOpenFilter(false);
  };

  return (
    <>
      <Filter
        open={openFilter}
        filters={filters}
        setFilters={setFilters}
        onClose={() => setOpenFilter(false)}
        sendFilter={handleSendFilter}
        hasNuSolicitacao={true}
        hasNuDAE={true}
      />
      <CardHolder
        title={intl.formatMessage({ id: 'LABELS.COMMONS.PENDINGS_DAES' })}
        handleFilter={() => setOpenFilter(true)}
      >
        <div className={classes.internalContainer}>
          {loading && (
            <div className={classes.centerProgress}>
              <CircularProgress size={20} />
            </div>
          )}
          {!loading && !!data && data.length > 0 && (
            <CustomTable columns={columns} data={data} onclick={onClick} />
          )}
        </div>
      </CardHolder>
    </>
  );
}

export default injectIntl(FinancialPendencies);
